import { API_APP_NAME, RequestMethod } from '~/shared/constants'
import { ApiService } from '~/shared/services'
import { IRawVariant, IRequestOptions, IResponseResult } from '~/shared/types'

export class VariantsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getVariant({
    cohort,
  }: {
    cohort: string
  }): Promise<IResponseResult<IRawVariant>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      params: { cohort },
    }

    return this.api.makeRequest<IRawVariant>(
      `v1/flow/${API_APP_NAME}/variants`,
      options,
    )
  }
}
